import {
  Alert,
  AuthActions,
  Phone,
  SET_ALERT,
  SET_LOADING,
  SET_PHONE,
  SET_STEP,
  SET_VERIFY_CODE
} from './types';


export function setLoading(loadingState: boolean): AuthActions {
  return {
    type: SET_LOADING,
    payload: loadingState
  }
}

export function setAlert(alert: Alert): AuthActions {
  return {
    type: SET_ALERT,
    payload: alert
  }
}

export function setStep(step: number): AuthActions {
  return {
    type: SET_STEP,
    payload: step
  }
}

export function setVerifyCode(code: string): AuthActions {
  return {
    type: SET_VERIFY_CODE,
    payload: code
  }
}

export function setPhone(phone: Phone): AuthActions {
  return {
    type: SET_PHONE,
    payload: phone
  }
}
